import React, { useMemo } from 'react';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import HealthQuestionnaireEntryPageStore, {
  HealthQuestionnaireEntryPageStoreContext,
} from 'store/pages/subscriber/imq/health-questionnaire-entry/pageStore';
import PageContent from 'components/subscriber/imq/health-questionnaire-entry';

const HealthQuestionnaireEntryPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();

  const pageStore = useMemo(
    () => new HealthQuestionnaireEntryPageStore({ groupId, subscriberId, entityId }),
    [groupId, subscriberId, entityId],
  );

  return (
    <HealthQuestionnaireEntryPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </HealthQuestionnaireEntryPageStoreContext.Provider>
  );
};

export default HealthQuestionnaireEntryPage;
